module.exports = "<div class=card style=min-height:100vh ng-if=!$ctrl.loadComplete> <spn-loading></spn-loading> </div> <div style=min-height:100vh ng-if=$ctrl.loadComplete> <div> <div class=\"card clearfix\"> <div layout=row> <bazaryab-admin-header></bazaryab-admin-header> <bazaryab-admin-nav></bazaryab-admin-nav> <div ui-view ng-class=\"{'nav-open':$ctrl.$mdSidenav('bazaryab-admin-nav').isOpen()}\" class=main-content></div> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/bazaryab-admin/bazaryab-admin.template.html
// module id = 74
// module chunks = 0